import { FedwireTransaction, TransactionRequest } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useFetchFedwireWithdrawTransaction({ bearer }: { bearer: string }) {
  const [fetching, setFetching] = useState(false);
  const [fedwireWithdrawTransaction, setFedwireWithdrawTransaction] = useState<FedwireTransaction>();

  async function fetchFedwireWithdrawTransaction(params: TransactionRequest) {
    try {
      setFetching(true);
      const res = await api.fetchFedwireWithdrawTransaction(params, bearer);
      if (!res.Success) throw new Error(res.ErrorMessage);
      setFedwireWithdrawTransaction(res);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, fedwireWithdrawTransaction, fetchFedwireWithdrawTransaction };
}
